
import { defineComponent, PropType } from "vue";
import { mdiReload } from "@mdi/js";
import {
  isSlotColumnConfig,
  isPropertyColumnConfig,
} from "../table-configuration";

import type { AsyncPaginationState } from "./types";
import CustomTable from "../CustomTable.vue";
import { PropsDef as CustomTablePropsDef } from "../CustomTable.vue";

export default defineComponent({
  name: "PaginatedTable",
  props: {
    ...CustomTablePropsDef,
    pageSize: {
      type: Number,
      default: 10,
    },
    longPaginatorThreshold: {
      type: Number,
      default: 8,
    },
    asyncPaginationState: {
      type: Object as PropType<Pick<
        AsyncPaginationState,
        "totalElements"
      > | null>,
      default: null,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    tableClasses: {
      type: Array,
      default: () => [
        "is-narrow",
        "is-striped",
        "is-hoverable",
        "is-fullwidth",
      ],
    },
  },
  data() {
    return {
      mdiReload,
    };
  },
  computed: {
    pages(): number[] {
      if (!this.asyncPaginationState) {
        return [];
      }
      const pageCount =
        this.asyncPaginationState.totalElements <= 0
          ? 0
          : Math.ceil(this.asyncPaginationState.totalElements / this.pageSize);
      return Array.from(Array(pageCount).keys()).map((e) => e + 1);
    },
    slotNames(): string[] {
      if (this.columnsConfig == undefined) {
        return [];
      }
      return this.columnsConfig
        .filter(isSlotColumnConfig)
        .map((e) => e.slotName);
    },
  },
  methods: {
    onPaginationClick(pageNum: number) {
      this.$emit("paginationClick", { pageClicked: pageNum });
    },
    isSlotColumnConfig,
    isPropertyColumnConfig,
  },
  emits: {
    paginationClick() {
      return true;
    },
  },
  components: {
    CustomTable,
  },
});
